import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var GitCommit = function GitCommit(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M16 12c0 2.2091-1.7909 4-4 4s-4-1.7909-4-4m8 0c0-2.2091-1.7909-4-4-4s-4 1.7909-4 4m8 0h6M8 12H2.0002"
    })
  }));
};
export default GitCommit;